module.exports = __webpack_public_path__ + "img/home_hd_01.8444b602.png";